import { ObjectHandleRepository } from 'util/services/objectHandleRepository';

/**
 * @ngdoc directive
 * @name phoenix.directive:pxDebounceImage
 * @module phoenix
 * @restrict A
 * @description
 *
 * A directive to delay loading of image src and is to be used in conjunction with 
 * md-virtual-repeat to limit getting thumbnails or pages if they are scrolled out
 * of the DOM.
 *
 * @usage
 *
 * <img px-debounce-image="{{ctrl.imgScr}}" />
 *
 */
export function DebounceImageDirective(
	$q:ng.IQService,
	$timeout:ng.ITimeoutService, 
	$mdMedia,
	objectHandleRepo:ObjectHandleRepository,
	pxAuthUriFilter:(uri:string) => string
) {
	return {
		restrict: 'A',
		link: function (scope, element:JQLite, attrs) {
			let request:ng.IPromise<any>;			
			const load = () => {
				cancel();
				request = loadImage(element, attrs.pxDebounceImage, attrs.asDataUri === 'true');
				request					
					.catch(e => {
						// if this is throwing, it's likely because the timeout was cancelled, which is acceptable
						if(e !== 'canceled'){
							throw e;
						}	
					})
					.finally(() => request = null);
			};
			const cancel = () => {
				if(request){
					$timeout.cancel(request);
					request = null;
				}
			};

			attrs.$observe('pxDebounceImage', newVal => {
				if (newVal) { 
					load();
				}
			});
			scope.$on('$destroy', cancel);

			load();
		}
	};

	function loadImage(element:JQLite, imgSrc:string, useBlob:boolean = false) {
		const TIMEOUT_DELAY = $mdMedia('gt-sm') ? 550 : 1800; 
		let p:ng.IPromise<string>;

		return $timeout(() => {
			if(useBlob){
				p = objectHandleRepo.createFromUri(imgSrc);
			}
			else {
				p = $q.resolve(pxAuthUriFilter(imgSrc));
			}

			p.then(src => {
				if(element[0].tagName === 'IMG'){
					element.attr('src', '');
					element.attr('src', src);
				}
				else {
					let icon = element
						.parent()
						.find('md-icon')
						.css('display', 'none');
					element[0].style.backgroundImage = '';
					element[0].style.backgroundImage = `url(${src})`;
				}
			});

		}, TIMEOUT_DELAY);
	}
}


DebounceImageDirective.$inject = [
	'$q',
	'$timeout', 
	'$mdMedia',
	'objectHandleRepository',
	'pxAuthUriFilter'	
];


// WEBPACK FOOTER //
// ./src/phoenix/components/debounceImage/debounceImage.ts